// extracted by mini-css-extract-plugin
module.exports = {"Layer":"📚4-7-0Nerse","ModalLayer":"📚4-7-0nN5QH","Translucent":"📚4-7-03bAE5","Transparent":"📚4-7-03SaiR","disableScroll":"📚4-7-01m1i6","Container":"📚4-7-029iS2"};